import React from 'react';
import { Button } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';

function Language(props: { variant: any }): JSX.Element {
  const { t, i18n } = useTranslation('component');
  const queryParameters = new URLSearchParams(window.location.search);
  const navigate = useNavigate();
  const location = useLocation();

  const changeLanguage = () => {
    const oldLang = i18n.resolvedLanguage;
    const newLang = oldLang == 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(newLang).then(() => {
      const pattern = new RegExp(`^\/${oldLang}`, 'i');
      let newUrl = location.pathname.replace(pattern, `/${newLang}`);

      const path = location.pathname.split('/' + oldLang)[1];
      newUrl = newUrl.replace(path, t('Path.' + path.toLocaleLowerCase()));

      if (queryParameters.toString().length > 0) newUrl += '?' + queryParameters.toString();

      navigate(newUrl, { replace: true });
    });
  };

  return (
    <Box>
      <Button style={{ color: '#002342' }} variant={props.variant} size="small" onClick={changeLanguage}>
        {t('Languages.ChangeTo')}
      </Button>
    </Box>
  );
}

export default Language;
